<!-- `step-3.component.html` -->
<div class="form-group form-button-container">
  <!-- Horarios disponibles -->
  <div class="form-group" *ngIf="horariosDisponibles.length > 0">
    <label class="form-label">Horarios Disponibles</label>
    <div class="horarios-disponibles">
      <button type="button" *ngFor="let horario of horariosDisponibles" (click)="toggleHorario(horario.id_horario)" [class.selected]="selectedHorarios.includes(horario.id_horario)">
        {{ horario.hora_inicio }} - {{ horario.hora_fin }}
      </button>
    </div>
  </div>
  <hr class="divider">
  <div class="form-group-tarifa">
    <div class="form-row">
      <span class="form-label">Cantidad de Horas:</span>
      <span class="valor">{{ totalHorasSeleccionadas }}</span>
    </div>
    <div class="form-row">
      <span class="form-label">SubTotal:</span>
      <span class="valor">S/. {{ subtotalPrice }}</span>
    </div>
    <div class="form-row input-group">
      <input class="descuento" type="number" placeholder="%" (input)="calculateTotal()" />
      <input class="motivo" type="text" placeholder="Motivo de descuento"/>
    </div>
    <div class="form-row total-row">
      <span class="form-label"><strong>Total:</strong></span>
      <span class="valor total"><strong>S/. {{ totalPrice }}</strong></span>
    </div>
  </div>

  <button type="button" class="form-button" (click)="createReserva()">Crear Reserva</button>
</div>
